export default "__VITE_ASSET__15bd7097__"